import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedContract, clearValidationError } from '../../../../../services/ContractService/contractSlice';

const PayerEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);
  const validationErrors = useAppSelector((state) => state.contract.validationErrors);

  const handleChange = (value: string) => {
    if (contract) {
      dispatch(updateSelectedContract({ payer: value }));
      if (validationErrors.payer) {
        dispatch(clearValidationError('payer'));
      }
    }
  };

  if (!contract) return null;

  return (
    <TextField
      label="Payer *"
      value={contract.payer}
      onChange={(e) => handleChange(e.target.value)}
      fullWidth
      variant="outlined"
      error={!!validationErrors.payer}
      helperText={validationErrors.payer}
      size="small"
    />
  );
};

export default PayerEditor;
